module.exports = __webpack_public_path__ + "img/tr.30802ce6.svg";